import { Text, Title } from "@clipboard-health/ui-react";
import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { type ReactElement, useState } from "react";

import { environmentConfig } from "../environment";
import { AppBarHeader, PageWithHeader, useToast } from "../lib";
import { DebugCards } from "./Cards/Cards";
import { DebugErrorPage } from "./DebugErrorPage";

export function DebugPage(): ReactElement {
  const { showErrorToast, showSuccessToast, showInfoToast, showWarningToast } = useToast();

  const TOASTS = {
    error: showErrorToast,
    info: showInfoToast,
    warning: showWarningToast,
    success: showSuccessToast,
  };
  const [shouldThrowError, setShouldThrowError] = useState(false);

  const environmentVariables = [
    { name: "REACT_APP_ENVIRONMENT_NAME", value: environmentConfig.REACT_APP_ENVIRONMENT_NAME },
    { name: "REACT_APP_VERSION_NAME", value: environmentConfig.REACT_APP_VERSION_NAME ?? "" },
    {
      name: "REACT_APP_BITRISE_BUILD_NUMBER",
      value: environmentConfig.REACT_APP_BITRISE_BUILD_NUMBER ?? "???",
    },
    {
      name: "REACT_APP_DATADOG_RUM_SOURCEMAP_VERSION",
      value: environmentConfig.REACT_APP_DATADOG_RUM_SOURCEMAP_VERSION ?? "???",
    },
  ];

  return (
    <PageWithHeader appBarHeader={<AppBarHeader title="Debug Page" />} containerMaxWidth="md">
      <Stack spacing={2}>
        <TableContainer
          sx={{
            display: "flex",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Environment Variable</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {environmentVariables.map((environmentVariable) => (
                <TableRow key={environmentVariable.name}>
                  <TableCell>{environmentVariable.name}</TableCell>
                  <TableCell>
                    <b>{environmentVariable.value}</b>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Text variant="h2" color="error">
          Testing error color override. If this is black, then the `cbhAppV1` class is overriding
          headings.
        </Text>
        {Object.keys(TOASTS).map((toastName) => {
          return (
            <Button
              key={toastName}
              variant="contained"
              onClick={() => {
                TOASTS[toastName as keyof typeof TOASTS](
                  `You clicked ${toastName}. This is a very long toast, so check it out.`
                );
              }}
            >
              Show {toastName}
            </Button>
          );
        })}
        <Title component="h1">Timezone debugging</Title>
        <Title component="h1">Error Logging</Title>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            throw new Error(`Debugger Error for Frontend Testing.`);
          }}
        >
          Throw an Error
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            setShouldThrowError(true);
          }}
        >
          Render an Error Component
        </Button>
        <DebugErrorPage shouldThrowError={shouldThrowError} />
        <Title component="h1">Route Debugging</Title>
        <DebugCards
          cards={[
            {
              id: 1,
              content: <Text>Open Shifts</Text>,
              to: "/home/openShifts",
            },
            {
              id: 2,
              content: <Text>Pull To Refresh Debugger</Text>,
              to: "/home-v2/debug/pull-to-refresh",
            },
          ]}
        />
      </Stack>
    </PageWithHeader>
  );
}
